import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=013d2db2&"
import script from "./Message.vue?vue&type=script&lang=ts&"
export * from "./Message.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013d2db2')) {
      api.createRecord('013d2db2', component.options)
    } else {
      api.reload('013d2db2', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=013d2db2&", function () {
      api.rerender('013d2db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/utilities/Message.vue"
export default component.exports